export const SET_SERVICES_LIST = "SET_SERVICES_LIST";
